import { bareHttp } from '@/core/api/http'
import { PORTAL_AUTH_CLIENT, getPortalAccessQrToken, getPortalAccessToken } from '@/core/auth/portal-storage'
import { getAccessToken } from '@/core/auth/storage'

export const PORTAL_ACCESS_REAUTH_KEY = 'gee.portal_access_reauth'

export function markPortalAccessReauth(): void {
  try {
    sessionStorage.setItem(PORTAL_ACCESS_REAUTH_KEY, '1')
  } catch {
    // ignore
  }
}

export function consumePortalAccessReauth(): boolean {
  try {
    const marked = sessionStorage.getItem(PORTAL_ACCESS_REAUTH_KEY) === '1'
    sessionStorage.removeItem(PORTAL_ACCESS_REAUTH_KEY)
    return marked
  } catch {
    return false
  }
}

/** True when the given session’s user belongs to this access QR (onsite vs recruitment, plus scope). */
export async function sessionMatchesAccessQr(
  access: string,
  session: 'crm' | 'portal',
): Promise<boolean> {
  const token = session === 'portal' ? getPortalAccessToken() : getAccessToken()
  const qr = access.trim()
  if (!token || qr.length < 20) return false
  try {
    const { data } = await bareHttp.get<{ data?: { matched?: boolean } }>(
      '/recruitment/portal-access-qrs/match',
      {
        params: { access: qr },
        headers: {
          Authorization: `Bearer ${token}`,
          ...(session === 'portal' ? { 'X-Auth-Client': PORTAL_AUTH_CLIENT } : {}),
        },
      },
    )
    return data?.data?.matched === true
  } catch {
    return false
  }
}

export function boundPortalAccessQr(): string {
  return getPortalAccessQrToken()?.trim() || ''
}
